<template>
  <div class="footer bg-dark pt-5 pb-3 text-white" >

    <div class="container" >
      <div class="row">
        <div class="col-6 col-md-3">
          <div v-on:click="getGDPR">개인정보 이용 약관</div>
<!--          <span data-toggle="collapse" data-target="#gdpr-tnc" area-expanded="false">개인정보 이용 약관</span>-->
        </div>
        <div class="col-6 col-md-3">
          <div v-on:click="getCheckList">사전점검 사항</div>
        </div>
        <div class="col-6 col-md-3">
          <div v-on:click="getFreightTnd">국제운송 약관</div>
          <!--          <span data-toggle="collapse" data-target="#gdpr-tnc" area-expanded="false">개인정보 이용 약관</span>-->
        </div>
        <div class="col-6 col-md-3">
          <div v-on:click="getInsuranceTnc">적하보험 안내 및 신청</div>
          <!--          <span data-toggle="collapse" data-target="#gdpr-tnc" area-expanded="false">개인정보 이용 약관</span>-->
        </div>
        <div class="col-6 col-md-3">
          <div v-on:click="getImportReasonForm">반입 사유서</div>
          <!--          <span data-toggle="collapse" data-target="#gdpr-tnc" area-expanded="false">개인정보 이용 약관</span>-->
        </div>
        <div class="col-6 col-md-3">
          <div v-on:click="getMoveApplicationForm">이사화물 신고서</div>
          <!--          <span data-toggle="collapse" data-target="#gdpr-tnc" area-expanded="false">개인정보 이용 약관</span>-->
        </div>
      </div>
<!--      <div class="row collapse" id="gdpr-tnc">-->
<!--        <div class="col-12"  >-->
<!--          <div class="tnc-container"  style="background: white;" v-html="tncContent">-->

<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>

    <h4 class="footer-title text-center font-weight-bold" style="color:white;">
      <img src="@/assets/img/uk.svg" height="30px" />
      <img src="@/assets/img/ko.svg" height="30px" />
      <br />
      UKO Shipping Ltd(유코쉬핑)
    </h4>

    <div class="container">
      <div class="row">
        <div class="col-12 col-md-4">
            유코쉬핑 런던본사<br>
            Unit 7 Caker Stream Road, Alton, England GU34 2QA
            <br>
            Tel: +44 7837 203 341
            <br>
            VAT: GB140620947
        </div>
        <div class="col-12 col-md-4">
          유코쉬핑 서울지사<br>
          담당자 : 임 채형 지사장<br>
          TEL: 010 6263 6533<br>
          E MAIL : ych@ukoshipping.com
        </div>
        <div class="col-12 col-md-4">
          유코쉬핑 부산지사<br>
          담당자 : 양 원석 이사<br>
          TE: 051 512 512 1212 / 010 3858 6742
        </div>
      </div>
    </div>


    <div class="tnc-viewer" v-if="tncItem != false">
      <div class="tnc-viewer-container">
        <div class="container h-100" style="overflow-y: scroll">
          <div class="row" style="padding-bottom: 100px;">
            <div class="col-12" v-if="tncItem.content != false" v-html="tncItem.content">

            </div>
            <div class="col-12" v-else-if="tncItem.pdfContent != undefined">
              <object width='100%' height='600px' :data='tncItem.pdfContent' type='application/pdf'></object>
            </div>

            <div class="col-12" v-if="tncItem.contentUrl != undefined && tncItem.contentUrl.length > 0">
              <embed class="pdf-viewer" :src="tncItem.contentUrl"/>
            </div>
          </div>
          <div class="row fixed-bottom" style="color: black;">
            <div class="col-6">
              <button class="form-control btn btn-secondary" v-on:click="closeTnc">
              <i class="fas fa-times"></i> 닫기
              </button>
            </div>
            <div class="col-6" v-if="tncItem.link != false">
              <button class="form-control btn btn-primary">
                <a :href="tncItem.link" download style="color:white;"><i class="fas fa-download"></i> 양식 다운로드</a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const axios = require('axios');

  import EventBus from '../api/event-bus.js';

  export default {
    name: 'Footer',
    data() {
      return {
        tncContent:false,
        tncItem: false,
      }
    },
    created() {
      // this.getGDPR();
      EventBus.$on("tnc", this.openTnc);
    },
    methods: {
      getGDPR: function() {
        console.log("Get GDPR")
        let self = this;
        console.log("Get content")
        axios.get('/static/doc/UKOGDPR.html')
        .then(response => {
          // self.$data.tncContent = response.data;
          self.$data.tncItem = {
            content: response.data,
            link:'/static/doc/GDPR-consent.pdf',
          };
        })
        .catch(error=>{
          console.log("Failed to get gdpr doc");
        })
      },
      getFreightTnd: function() {
        console.log("Get international_transit_tnc")
        let self = this;
        console.log("Get content")
        axios.get('/static/doc/internation_transit_tnc.html')
          .then(response => {
            // self.$data.tncContent = response.data;
            self.$data.tncItem = {
              content: response.data,
              link:false,
            };
          })
          .catch(error=>{
            console.log("Failed to get gdpr doc");
          })
      },
      getInsuranceTnc: function() {
        console.log("Get international_transit_tnc")
        let self = this;
        console.log("Get content")
        axios.get('/static/doc/insurance.html')
          .then(response => {
            // self.$data.tncContent = response.data;
            self.$data.tncItem = {
              content: response.data,
              link:'/static/doc/uko-insurance-application.xlsx',
              type:'vnd.ms-excel',
              label:'UKO Insurance Application.xlsx',
            };
          })
          .catch(error=>{
            console.log("Failed to get gdpr doc");
          })
      },
      getCheckList: function() {
        console.log("Get check list")
        let self = this;
        console.log("Get content")
        axios.get('/static/doc/checkList.html')
          .then(response => {
            // self.$data.tncContent = response.data;
            self.$data.tncItem = {
              content: response.data,
              link:false,
            };
          })
          .catch(error=>{
            console.log("Failed to get gdpr doc");
          })
      },
      getImportReasonForm: function() {
        this.$data.tncItem = {
          contentUrl:'/static/doc/import_reason_form.pdf',
          content: false,
          link:'/static/doc/import_reason_form.pdf',
        };
        // console.log("Get GDPR")
        // let self = this;
        // console.log("Get content")
        // axios({
        //   url:'/static/doc/import_reason_form.pdf',
        //   method:'GET',
        //   responseType:'blob',
        // })
        // // axios.get('/static/doc/import_reason_form.pdf')
        //   .then(response => {
        //     // self.$data.tncContent = response.data;
        //     self.$data.tncItem = {
        //       pdfContent: URL.createObjectURL(response.data),
        //       link:'/static/doc/import_reason_form.pdf',
        //     };
        //   })
        //   .catch(error=>{
        //     console.log("Failed to get gdpr doc");
        //   })
      },
      getMoveApplicationForm: function() {
        this.$data.tncItem = {
          contentUrl:'/static/doc/move_application.pdf',
          content: false,
          link:'/static/doc/move_application.pdf',
        };
      },
      openTnc: function(tnc) {
        this.closeTnc();
        if(tnc === 'GDPR') {
          this.getGDPR();
        } else if(tnc === 'insurance') {
          this.getInsuranceTnc();
        } else if(tnc === 'freight') {
          this.getFreightTnd();
        } else if(tnc === 'checkList') {
          this.getCheckList();
        } else if(tnc === 'importReason') {
          this.getImportReasonForm();
        } else if(tnc === 'moveApplication') {
          this.getMoveApplicationForm();
        }
      },
      closeTnc: function() {
        this.$data.tncItem = false;
      },
      downloadItem: function (item) {
        let url = item.url;
        let label = item.label;
        axios({
          method: 'get',
          url: url,
          responseType: 'arraybuffer',
          crossDomain: true
        })
          .then(response => {

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', label) //or any other extension
            document.body.appendChild(link)
            link.click()

          })
          .catch(function(err) {
            console.log(err);
          })
      }

    }
  };
</script>

<style>
  .tnc-container {
    padding:10px;
    border-radius: 10px;
  }
  .tnc-viewer {
    position: fixed;
    width: 100%;
    height: 100%;
    top:0;
    left:0;
    background: rgba(0,0,0,0.3);
  }
  .tnc-viewer-container {
    width: 90%;
    height: 90%;
    position: absolute;
    top:50%;
    left: 50%;
    background: white;
    color: black;
    transform: translate(-50%,-50%);
  }
  .tnc-close-btn {
    position: absolute;
    top:10px;
    right:10px;
    color: black;
  }
  .question {
    width: 100%;
    padding: 10px;
    background: #eee;
    margin-top:20px;
    border-left: 5px solid red;
    word-wrap: break-word;
    font-weight: bold;
  }
  .answer {
    width: 100%;
    padding-right: 10px;
    padding-left: 10px;
    border-left: 5px solid blue;
    background: #F5F5F5;
    word-wrap: break-word;
  }
  .c6 {
    max-width: 100%;
  }
  .pdf-viewer {
    position: fixed;
    width: 90%;
    height: 90%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue